export default __webpack_public_path__ + "2e059682dfb4b302da5f0b9dd5133fb0.png";